<template>
  <div style="width: 100%; padding-bottom: 4.33333rem; background: url(/img/home/g.f7e76bcc.png) repeat top / 100% auto;">
    <div>
      <van-nav-bar  left-arrow @click-left="onClickLeft">
        <template #left>
          <van-icon name="arrow-left" size="22" color="#fff" />
        </template>
      </van-nav-bar>
    </div><div style="background: linear-gradient(90deg, #f560cd, #4f2b8a);height: 90px;border-radius: 0px 0px 20px 20px"></div><div style="width: 100%;margin-top: -80px"><div style="display: flex;justify-content: flex-start;align-items: flex-start;width: 90%;margin: 4% auto 0;">
	<div style="border-radius: 10px;
    overflow: hidden;width: 120px;
    height: 120px;"><img :src="data.one" style="object-fit: cover;width: 120px;
    height: 120px;"></div><div style="display: flex;justify-content: flex-start;align-items: flex-start;flex-direction: column;padding-left: 1rem;flex: 1;">
<p style="color: #fff;font-size: 1.06667rem;">{{ data.xuanfei_name }}<span data-v-c68166c8="" style="margin-left: 10px; color: rgb(250, 154, 10); font-size: 13px; font-weight: 600;">{{data.id}}</span></p>
<div style="height: 28px;margin-top:4px;"><img src="/img/home/rz.71425b8f.png" style="width: 62px;height: 28px" alt="" data-v-c68166c8=""></div>
<div style="width: 100%;display: flex;justify-content: flex-start;align-items: center;margin-top: 2px;"><p style="font-size: .8rem;color: #fc4f2c;font-weight: 600;">{{$t("foorter.top8")}}</p></div></div>
	</div></div><div style="display: flex;justify-content: flex-start;align-items: flex-start;width: 90%;margin: 4% auto 0;"></div>
    <div class="feiziInfo" style="background: url(/img/home/g.f7e76bcc.png) repeat top / 100% auto;">
      <div class="topInfo">
        <div><span>{{$t("foorter.top11")}}</span></div><div  class="imgswiper" >
              <div
                v-for="(i,index) in data.img_url" :key="index"
                style="width: 178px; height: 184px; margin-right: 10px;"
              >
                <div
                 

                  style="width: 178px; height: 184px;"
                >
                  <img
                    :src="i"
                    class="van-image__img"
                    style="object-fit: cover;"
					@click="imgShow(i)"
                  />
                </div>
              </div>
         
          
            </div><div style="padding: 15px 0px;font-size: 16px;">{{$t("foorter.top10")}}</div>
        
        
        <div style="width: 100%;">
          <div class="item" v-for="(item,index) in data.flagArray" :key="index">{{item}}</div>
         
        </div><div style="color: #6b22b3; font-size: 3vw; margin: 10px 0">
          {{$t("index.height")}}:{{ data.hight }} {{$t("index.bust")}}：{{ data.bust }}
        </div>
		
        <!----><!---->
        <div>
          <span style="color: rgb(107, 34, 179); font-size: 14px;"
            >{{$t("foorter.top9")}}</span
          >
          <van-rate v-model="data.number" readonly    color="#ffd21e" size="18px" />
        </div>
        <div
          style="color: rgb(107, 34, 179); font-size: 14px; margin: 4px 0px;"
        >
        {{$t("index.residence")}}：{{ data.class_name }}
        </div><div style="padding: 15px 0px;font-size: 16px;">{{$t("foorter.top12")}}</div><div class="movie-video" style="margin: 10px;">
<div class="movie-video">
<video id="my-video" class="video-js"></video>
</div>
    </div><h4 style="margin-top: 20px;">{{$t("foorter.top13")}}</h4><p style="padding: .66667rem 0;
    color: #28211f;">{{$t("foorter.top14")}}</p>
        <div class="yuyueBox" @click="getUserGameList" style="display: none;">{{$t("index.instant_booking")}}</div>
        <div class="dianzanimg" @click="clickPraise" style="display:none">
          <div class="van-image" style="width: 60px; height: 60px;">
            <img
              src="/img/zan.c28032c8.png"
              class="van-image__img"
              style="object-fit: cover;"
            />
          </div>
          <p style="color: rgb(107, 34, 179); margin: 0px;">
            {{ data.dianzan }}
          </p>
        </div>
      </div>
    </div><div style="background: linear-gradient(90deg, #f560cd, #4f2b8a);position: fixed;bottom: 10px;
    color: #fff;
    width: 70%;
    height: 32px;
    border-radius: 10px;margin-left: 15%;
    font-size: 16px;line-height:32px;text-align: center;" @click="toServicePage()">{{$t("foorter.top15")}}</div>
  </div>
</template>

<script>
import videojs from 'video.js';
import "videojs-contrib-hls";
export default {
  data() {
    return {
      showMsg:false,
      data: {},
      currentIndex: 0,
      currentImage: '',cover: "",nowPlayVideoUrl: "",
      isPraised: false,
      player: null,
    };
  },
  methods: {
    getxuanfeidata() {
			this.$http({
				method: 'get',
				url: 'xuanfeidata',
				data: { id: this.$route.query.id }
			}).then(res => {
        this.data = res.data;
		this.nowPlayVideoUrl=res.data.pvideo ? res.data.pvideo.replace(/^http:\/\//i, 'https://') : '';
		this.cover =res.data.one;
		let videos = document.getElementById("my-video");  
		videos.poster = this.cover;
		this.getVideo();
        const lanng = this.$t("auth.lang");
        // this.data.flag.forEach(item => {
        //   const parts = item.flag.split('|')
        //   item.flag = parts[0]
        //   item.flagArray = item.flag.split('，');

        // })
        const parts = this.data.flag.split('|')
        console.log(parts,987)
        lanng == 'hk'? this.data.flag = parts[0]:lanng == 'en'? this.data.flag = parts[1]:this.data.flag = parts[0]
        this.data.flagArray = this.data.flag.split('，');
        this.currentImage = this.data.img_url[0];
        console.log(this.data,998)
			});
    },getBasicConfig() {
      this.$http({
        method: "get",
        url: "sys_config",
      }).then((res) => {this.kefu = res.data.kefu;
        // this.getGameItem();//获取首页游戏列表
        // this.getMovieList_0(this.basicData);//获取首页视频0
        // this.getMovieList_1(this.basicData);//获取首页视频1
      });
    },

    onClick(name) {
      console.log(name);
      if (name === 'phone') {
        this.showMsg = false
        if (this.player) {
          this.player.pause(); 
         // 确保 player 被置为空
        }
      } else {
        this.showMsg = true
   
     
      }
 
    },
    onClickImg(index) {
      this.currentIndex = index;
      this.currentImage = this.data.img_url[index];
    },
    onClickLeft() {
      this.$router.go(-1)
    },
    clickPraise() {
      if (this.isPraised) {
        // 如果已经点赞，则减1
        this.data.dianzan --;
        this.isPraised = false;
      } else {
        // 如果未点赞，则加1
        this.data.dianzan ++;
        this.isPraised = true;
      }
    },imgShow(index) {
      const image = new Image()
      image.src = index
      image.onload = () => {
        //创建弹出层
        const previewContatiner = document.createElement('div')
        previewContatiner.style.position = 'fixed'
        previewContatiner.style.top = 0
        previewContatiner.style.bottom = 0
        previewContatiner.style.left = 0
        previewContatiner.style.right = 0
        previewContatiner.style.zIndex = 9999
        previewContatiner.style.backgroundColor = 'rgba(0,0,0,0.8)'
        previewContatiner.style.display = 'flex'
        previewContatiner.style.justifyContent = 'center'
        previewContatiner.style.alignItems = 'center'
        document.body.appendChild(previewContatiner)
        //在弹出层增加图片
        const previewImage = document.createElement('img')
        previewImage.src = index
        previewImage.style.maxWidth = '80%'
        previewImage.style.maxHeight = '80%'
        previewImage.style.zIndex = 9999
        previewContatiner.appendChild(previewImage)
        //点击弹出层，关闭预览
        previewContatiner.addEventListener('click', () => {
          document.body.removeChild(previewContatiner)
        })
      }
      image.onerror = function () {
        console.log('图片加载失败')
      }
    },toServicePage(){
		console.log(this.kefu)
		window.location.href = this.kefu
      // this.$router.push("ServicePage");
    },getVideo() {
      let videoType = "application/x-mpegURL";
      const url = this.nowPlayVideoUrl;
      if (url && (url.endsWith(".mp4") || url.endsWith(".MP4"))) {
        videoType = "video/mp4";
      } else if (url && (url.endsWith(".webm") || url.endsWith(".WEBM"))) {
        videoType = "video/webm";
      } else if (url && (url.endsWith(".ogg") || url.endsWith(".OGG"))) {
        videoType = "video/ogg";
      }
      this.player.src([
        {
          src: url,
          type: videoType,
        },
      ]);
      this.player.poster(this.cover);
    },
    getUserGameList(){
      this.$http({
        method: 'get',
        url: 'user_get_game_list'
      }).then(res=>{
        if(res.code === 200){
          this.$toast('먼저 활성화 작업을 완료하십시오.');
          this.list = res.data;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    this.getxuanfeidata();this.getBasicConfig();
	
  },
  mounted() {
const _this = this;
this.player = videojs(
"my-video",
{
height: "200px",
preload: "auto", // 预加载
controls: true, // 显示播放的控件
multipleArray: [0.75, 1, 1.5, 2], // 倍速设置
},
function () {
this.on("play", () => {
_this.is_play = true;
});
}
);
  },
  beforeDestroy() {
    // 销毁video.js播放器实例，避免内存泄漏
    if (this.player) {
      this.player.dispose();
      this.player = null;
    }
    if (this.is_play) {
      this.is_play = false;
    }
  },
};
</script>

<style scoped lang="less">
.van-nav-bar {
  background: linear-gradient(90deg, #f560cd, #4f2b8a);height: 44px;
}
.van-nav-bar .van-icon {
  color: #fff !important;
}
.feiziInfo {
  background: url(/img/home/g.f7e76bcc.png) repeat top / 100% auto;
}
.topInfo {
  position: relative;
  padding: 4vw 40px;
  background: #fff;
}
.feiziInfo .topInfo div:first-child span:first-child {
  color: #2c1868;
  font-size: 5vw;
}
.topInfo .item {
  background: linear-gradient(50deg, #9b54ca, #e6557f);
  color: #fff;
  display: inline-block;
  border-radius: 20px;
  margin-right: 30px;
  font-size: 24px;
  padding: 16px;
  margin-bottom: 30px;
}
.yuyueBox {
  position: absolute;
  right: 4vw;
  bottom: 40px;
  color: #fff;
  padding: 20px 30px;
  background: linear-gradient(20deg, #e73266, #ee5380);
  border-radius: 7vw;
}
.dianzanimg {
  position: absolute;
  top: 4vw;
  right: 7vw;
  text-align: center;
}
.cenInfo {
  padding: 4vw 20px;
  background: #fff;
  
}
.imgswiper{
  width: 100%;
    overflow-x: scroll;
    margin: 4vw 0;
    display: flex;
    flex-wrap: nowrap;
}
.imgswiper .active{
  border: 10px solid #e54878;
}
.btmInfo{
  padding: 4vw 40px;
    background: #fff;
 
    
}
::v-deep .movie-video .video-js .vjs-big-play-button {
  top: 50%;
  left: 50%;
  margin-top: -50px;
  margin-left: -100px;
}
.video-js {
  width: 100%;
  height: 336px;
  font-size: 24px;
  
}
::v-deep .movie-video .video-js .vjs-big-play-button {
  top: 50%;
  left: 50%;
  margin-top: -50px;
  margin-left: -100px;
}
.movie-content .movie-body .movie-title {
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.movie-content .movie-body .movie-title > div:first-child {
  width: 410px;
}
.movie-content .movie-body .movie-title > div:first-child span {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 30px;
  font-weight: 700;
  color: #000;
}
.movie-content .movie-body .movie-title > div:first-child span:before {
  content: "";
  display: block;
  width: 8px;
  height: 30px;
  background-color: #7e5678;
  border-radius: 25px;
  margin-right: 10px;
}
</style>
